import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'DataProcessingDialogController',
            DataProcessingDialogController
        );

    function DataProcessingDialogController(
        $scope,
        GdprFactory,
        ngDialog,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.filePath = $scope.ngDialogData.filePath;
            vm.accept = accept;
        }

        function accept() {
            GdprFactory.acceptAgreement({
                agreement_type: 'data_processing',
            }).then(function () {
                toastr.success(
                    'Dziękujemy. Możesz dalej korzystać z iWykonawca.pl'
                );
                ngDialog.close();
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/agreements_dialogs/data_processing_dialog/data_processing_dialog.controller.ts